import {Table,ActivityIndicator} from 'antd-mobile' 

class Main extends React.Component {
		constructor(props) {
				super(props); 
		}
		render() {
			const {data} = this.props;
			if (!data) {
				return (
					<div className="csm-app-baseinfo-loading">
	        			<ActivityIndicator animating size="large" style={{backgroundColor:'#000'}}/>
	        		</div>
				)
			}
			const dev = data.dev || [];
			const columns = [{
					title: '名字',
					dataIndex: 'm_name',
					key: 'm_name',
			},{
					title: '账号',
					dataIndex: 'm_user',
					key: 'm_user',
			}];
			return <Table dataSource={dev} columns={columns} />
		}
}	

export default Main



// WEBPACK FOOTER //
// ./project/components/app/Developer.js